import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.125 14C7.03159 13.998 5.98353 13.5628 5.21037 12.7896C4.43722 12.0165 4.00198 10.9684 4 9.875V5C4 4.20435 4.31607 3.44129 4.87868 2.87868C5.44129 2.31607 6.20435 2 7 2C7.79565 2 8.55871 2.31607 9.12132 2.87868C9.68393 3.44129 10 4.20435 10 5V9.125C10 9.62228 9.80246 10.0992 9.45083 10.4508C9.09919 10.8025 8.62228 11 8.125 11C7.62772 11 7.15081 10.8025 6.79917 10.4508C6.44754 10.0992 6.25 9.62228 6.25 9.125V5H7.75V9.125C7.75 9.22446 7.78951 9.31984 7.85983 9.39017C7.93016 9.46049 8.02554 9.5 8.125 9.5C8.22446 9.5 8.31984 9.46049 8.39017 9.39017C8.46049 9.31984 8.5 9.22446 8.5 9.125V5C8.5 4.60218 8.34196 4.22064 8.06066 3.93934C7.77936 3.65804 7.39782 3.5 7 3.5C6.60218 3.5 6.22064 3.65804 5.93934 3.93934C5.65804 4.22064 5.5 4.60218 5.5 5V9.875C5.5 10.5712 5.77656 11.2389 6.26884 11.7312C6.76113 12.2234 7.42881 12.5 8.125 12.5C8.82119 12.5 9.48887 12.2234 9.98116 11.7312C10.4734 11.2389 10.75 10.5712 10.75 9.875V5H12.25V9.875C12.248 10.9684 11.8128 12.0165 11.0396 12.7896C10.2665 13.5628 9.21841 13.998 8.125 14Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
